import { showModal, hideModal } from 'actions/modal';
import type { Dispatch } from 'redux';

export const dispatchShowModal = (
    dispatch: Dispatch,
    modalName: string,
    modalProps: Record<string, unknown> = {},
) => {
    dispatch(
        showModal({
            type: modalName,
            props: { ...modalProps },
        }),
    );
};

export const dispatchHideModal = (dispatch: Dispatch) => {
    dispatch(hideModal());
};
